import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { Edit2, Trash2, X, Check } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from 'common'

export const TableCashier = ({ useFetchInit }) => {
    
    const {
        FetchData,
        Actions
    } = useFetchInit

    const { fetchAllCashiers } = FetchData
    const { dataCashiers, loadingFetchAllCashiers } = fetchAllCashiers

    const { 
        handleClickFetchSpecificCashier,
        handleClickEnableDisableCashier,
        handleClickDeleteCashier
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "categoria", headerName: "CATEGORIA", minWidth: 200, filter: true },
        { field: "descripcion_corta", headerName: "DESCRIPCION CORTA", minWidth: 400, filter: true },
        { field: "currency_type", headerName: "TIPO", minWidth: 150, filter: true },
        { field: "descripcion_larga", headerName: "DESCRIPCION LARGA", minWidth: 300, filter: true },
        { field: "efectivo_quetzales", headerName: "Total Q.", minWidth: 150, filter: true },
        { field: "efectivo_dolares", headerName: "Total $.", minWidth: 150, filter: true },
        { field: "retirable", headerName: "RETIRABLE", minWidth: 300, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idcaja, estado } = params.data

                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        {(estado === 1) && (
                            <div>
                                <MenuItem
                                    onClick={() => handleClickFetchSpecificCashier(idcaja)}
                                >
                                    <ListItemIcon> <Edit2 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Informacion" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickDeleteCashier(idcaja)}
                                >
                                    <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Eliminar" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickEnableDisableCashier(idcaja, 0)}
                                >
                                    <ListItemIcon> <X color="black"/> </ListItemIcon>
                                    <ListItemText primary="Desactivar" />
                                </MenuItem>
                            </div>
                        )}
                        {(estado === 0) && (
                            <MenuItem
                                onClick={() => handleClickEnableDisableCashier(idcaja, 1)}
                            >
                                <ListItemIcon> <Check color="black"/> </ListItemIcon>
                                <ListItemText primary="Activar" />
                            </MenuItem>
                        )}
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchAllCashiers)&&(<LinearLoading/>)}
            <CustomTableData
                rowConfig={dataCashiers}
                columnConfig={columnConfig}
            />
        </div>
    )
}
